<div id="otherActivities">
    <div class="row justify-between card-header px-6 py-3">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            Additional Updates
        </div>
        <button (click)="openDialog('Other Activites','otherActivities','createProgresBarChart')">
            <ng-container [ngTemplateOutlet]="expandIcon"></ng-container>
        </button>
    </div>

    <div class="px-6 py-2">
        <div style="height:45vh;" id="progressBarChart"></div>
    </div>
</div>